import { useState } from "react";
import { Layout } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import { Outlet } from "react-router-dom";
import icon from "../images/Icon.png";
import { Sidebar } from "./Sidebar";
import { useIsMobile } from "../shared/hooks/useIsMobile";

const { Sider, Content } = Layout;

export function MainLayout() {
  const isMobile = useIsMobile();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  if (isMobile) {
    return (
      <div className="backoffice-mobile-shell">
        <div className="backoffice-mobile-header">
          <img src={icon} alt="TrocaEnvio" className="backoffice-mobile-header__icon" />
          <button
            type="button"
            className="backoffice-mobile-header__toggle"
            onClick={() => setMobileMenuOpen((current) => !current)}
            aria-label="Abrir menu"
            aria-expanded={mobileMenuOpen}
          >
            <MenuOutlined />
          </button>
        </div>
        {mobileMenuOpen ? (
          <div className="backoffice-mobile-sidebar">
            <Sidebar isMobile onNavigate={() => setMobileMenuOpen(false)} />
          </div>
        ) : null}
        <main className="backoffice-content backoffice-content--mobile">
          <Outlet />
        </main>
      </div>
    );
  }

  return (
    <Layout className="backoffice-shell">
      <Sider width={248} style={{ background: "transparent" }}>
        <Sidebar />
      </Sider>
      <Layout className="backoffice-main">
        <Content className="backoffice-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
